module.exports = "/assets/data/01d605ba193279cfb3a61e294da37cb1-G82.data.json";